export enum IndustryEnum {
  StaffingRecruiting = 'Staffing and Recruiting',
  Others = 'Others',
}
